import React from "react"
import SubsectionContainer from "../../shared/SubsectionContainer"
import { useCMSReady } from "../../../../domain/CMS/useCMSReady"
import { mapAvailableDays } from "../../../shared/utils"
import { ProfileDaysOfOperation } from "./ProfileDaysOfOperation"
import { AvailableDisplayId } from "../../../../domain/Provider/schema"

interface AvailabilityContentProps {
  providerAvailableDisplayIds: AvailableDisplayId[]
  isAvailableEveningHours: boolean
}

export const AvailabilityContent: React.FC<AvailabilityContentProps> = ({
  providerAvailableDisplayIds,
  isAvailableEveningHours,
}) => {
  const { cms: cmsContent } = useCMSReady(["common", "publicProfileSlide"])
  const commonText = cmsContent.common
  const providerText = cmsContent.provider
  const availableDays = mapAvailableDays(providerAvailableDisplayIds)

  return (
    <SubsectionContainer>
      <ProfileDaysOfOperation
        eveningsAvailableText={
          providerText!.availabilityEveningHoursAvailableText
        }
        availableDays={availableDays}
        eveningsAvailable={isAvailableEveningHours}
        commonText={commonText!}
      />
    </SubsectionContainer>
  )
}
